'use strict';

var cov_bcmo87qn7 = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/userStatistic/userStatistic.js',
        hash = 'a1e7950807238b7500c6cd5909bbd3dc7a015de9',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/userStatistic/userStatistic.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 9,
                    column: 7
                }
            }
        },
        fnMap: {},
        branchMap: {},
        s: {
            '0': 0
        },
        f: {},
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_bcmo87qn7.s[0]++;
angular.module('app').component('userStatistic', {
    templateUrl: 'app/components/userStatistic/userStatistic.html',
    bindings: {
        statistic: '<',
        searchContent: '='
    }
});